<template>
	<div>
		<div v-if="cancelAccepted">
			<vs-chip color="danger">
				<vx-tooltip :text="`Annuleer verzoek geaccepteerd.`">
					Product geannuleerd
				</vx-tooltip>
			</vs-chip>
		</div>

		<div v-else-if="cancelRequest">
			<vs-chip color="warning">
				<vx-tooltip :text="`Klant heeft een annuleer verzoek ingediend.`">
					Annuleer verzoek
				</vx-tooltip>
			</vs-chip>
		</div>

		<div v-else>
			<vs-chip v-if="condition === 'NEW'">
				<vx-tooltip text="Product conditie" position="top">
					Nieuw
				</vx-tooltip>
			</vs-chip>
			<vs-chip v-if="condition === 'AS_NEW'">
				<vx-tooltip text="Product conditie" position="top">
					Gebruikt > Als nieuw
				</vx-tooltip>
			</vs-chip>
			<vs-chip v-if="condition === 'GOOD'">
				<vx-tooltip text="Product conditie" position="top">
					Gebruikt > Goed
				</vx-tooltip>
			</vs-chip>
			<vs-chip v-if="condition === 'REASONABLE'">
				<vx-tooltip text="Product conditie" position="top">
					Gebruikt > Redelijk
				</vx-tooltip>
			</vs-chip>
			<vs-chip v-if="condition === 'MODERATE'">
				<vx-tooltip text="Product conditie" position="top">
					Gebruikt > Matig
				</vx-tooltip>
			</vs-chip>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		condition: String,
		cancelRequest: Boolean,
		cancelAccepted: Boolean,
	},
}
</script>
